import { usePermissionRestriction } from '@shared/hooks'
import { AppPermissions } from '@shared/types'
import { Button, ButtonProps } from 'antd'
import { useState } from 'react'

import { PersonModalSelect } from './PersonModalSelect'
import { CommonType, PersonType } from './types'

type Props<M extends boolean, P extends PersonType = PersonType> = CommonType<
  M,
  P
> &
  Omit<ButtonProps, 'value'>

export function AddPersonButton<
  M extends boolean,
  P extends PersonType = PersonType
>({
  personType,
  multiple,
  value,
  onAdd,
  getTitle,
  getSubtitle,
  getExtra,
  ...props
}: Props<M, P>) {
  const { hasPermission } = usePermissionRestriction()
  const [isOpen, setIsOpen] = useState(false)

  const triggerModal = () => setIsOpen((isOpen) => !isOpen)

  if (!hasPermission([AppPermissions.SECTION_CUSTOMERS])) return

  return (
    <>
      <Button onClick={triggerModal} {...props} />

      <PersonModalSelect
        personType={personType}
        multiple={multiple}
        open={isOpen}
        value={value}
        onCancel={triggerModal}
        onAdd={onAdd}
        getTitle={getTitle}
        getSubtitle={getSubtitle}
        getExtra={getExtra}
      />
    </>
  )
}
